import { useLayoutEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import { GET_SUB_BET } from "../../graphql/games";
import GLoader from "../../components/ui/base/GLoader";

const SBOSport = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [loginSboBetPlayer] = useMutation(GET_SUB_BET);
    const [sboBetUrl, setSboBetUrl] = useState<any>(null);

    useLayoutEffect(() => {
        setIsLoading(true);
        (async () => {
            const {data} = await loginSboBetPlayer();
            console.log({data: data?.loginSboBetPlayer?.webLoginUrl});
            setSboBetUrl(data?.loginSboBetPlayer?.webLoginUrl);
            setIsLoading(false);
        })();
    }, []);
    
    return (
        <div className="w-full h-[100vh]">
            {isLoading && <GLoader />}
            {sboBetUrl && <iframe src={sboBetUrl} width="100%" height="100%" />}
        </div>
    );
};

export default SBOSport;